/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
/**
 * Datepicker data that requires internationalization.
 */
export class MdDatepickerIntl {
/**
 * Stream that emits whenever the labels here are changed. Use this to notify
 * components if the labels have changed after initialization.
 */
changes: Subject<void> = new Subject<void>();
/**
 * A label for the calendar popup (used by screen readers).
 */
calendarLabel = 'Calendar';
/**
 * A label for the button used to open the calendar popup (used by screen readers).
 */
openCalendarLabel = 'Open calendar';
/**
 * A label for the previous month button (used by screen readers).
 */
prevMonthLabel = 'Previous month';
/**
 * A label for the next month button (used by screen readers).
 */
nextMonthLabel = 'Next month';
/**
 * A label for the previous year button (used by screen readers).
 */
prevYearLabel = 'Previous year';
/**
 * A label for the next year button (used by screen readers).
 */
nextYearLabel = 'Next year';
/**
 * A label for the 'switch to month view' button (used by screen readers).
 */
switchToMonthViewLabel = 'Change to month view';
/**
 * A label for the 'switch to year view' button (used by screen readers).
 */
switchToYearViewLabel = 'Change to year view';
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDatepickerIntl_tsickle_Closure_declarations() {
/** @type {?} */
MdDatepickerIntl.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDatepickerIntl.ctorParameters;
/**
 * Stream that emits whenever the labels here are changed. Use this to notify
 * components if the labels have changed after initialization.
 * @type {?}
 */
MdDatepickerIntl.prototype.changes;
/**
 * A label for the calendar popup (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.calendarLabel;
/**
 * A label for the button used to open the calendar popup (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.openCalendarLabel;
/**
 * A label for the previous month button (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.prevMonthLabel;
/**
 * A label for the next month button (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.nextMonthLabel;
/**
 * A label for the previous year button (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.prevYearLabel;
/**
 * A label for the next year button (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.nextYearLabel;
/**
 * A label for the 'switch to month view' button (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.switchToMonthViewLabel;
/**
 * A label for the 'switch to year view' button (used by screen readers).
 * @type {?}
 */
MdDatepickerIntl.prototype.switchToYearViewLabel;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
